<template>
  <!--  万元金币规则-->
  <div class="cashRule">
    <div class="basic">
      <!--      <p class="cash-title">邀请好友规则</p>-->
      <p class="cash-content">1、参与方式：用户每天观看工伤预防或安全教育视频可获得一个幸运号（每天最多获取1个）。幸运号发放时间：每日00:00-19:50。用户可在活动页面“我的幸运号”中查看获取记录。</p>
      <p class="cash-content">2、幸运号抽取： 每日晚8点抽取本日幸运号100个（送2元金币）； 每周六晚8点分别抽取本周幸运号10个（送10元金币）、本日幸运号100个（送2元金币）；
        每月最后一日抽取当月幸运号1个（送1000元金币），逢周六依次抽取月幸运号、周幸运号、日幸运号； 每年最后一天从12个月幸运号中随机抽取年幸运号1个，送10000元金币。 用户可在活动页面“我的金币”中查看获取记录。</p>
      <p class="cash-content">3、金币提现：用户在“我的金币”页面可查看当前账户金币余额，并可联系邀工网客服提现金币。提现时需先在平台内进行实名认证，然后联系邀工网客服提供身份证信息用于核实领取人身份，
        提供手机号码（微信号）用于添加微信和发放奖励，经核实领取人和注册用户一致后，邀工网客服将通过微信转账的形式发放奖励。</p>
      <p class="cash-content">4、新老用户登录成功后均可参加活动。</p>
      <p class="cash-content">5、同一账号每日最多可以领取一个幸运号，幸运号可累积参与周、月幸运号抽取。</p>
      <p class="cash-content">6、本活动将根据用户反馈、活动效果等多方面因素，不定期对活动形式、活动奖品、活动周期、兑换规则等进行优化调整，具体以页面实际展示为准。</p>
      <p class="cash-content">7、本活动最终解释权归邀工网平台所有。</p>
      <p class="cash-content">8、如发现用户存在恶意违规行为，邀工网平台有权取消其活动资格，收回所有奖品，并予以处罚。如对平台造成损失的，将按照法律规定追究其相关责任。 </p>
      <p class="cash-content">
        9、邀工网《用户协议》、《隐私政策》等平台规范同样适用于本活动，活动规则及相关条款与其相冲突的，以本活动规则为准。本活动规则及相关条款未约定的内容，仍以邀工网《用户协议》、《隐私政策》等平台规范为准。</p>
      <p class="cash-content">
        10、如用户对活动及其相关规则有任何疑问或意见，请通过平台内“用户反馈”功能进行反馈或拨打客服电话：400-0900-190（9:00-18:00），我们将会有专人尽快处理。</p>
      <p class="cash-content">11、本规则自发布之日起立即生效。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cashRule',
  data () {
    return {}
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";

.cashRule {
  @include add_size($font_size_16);
  text-align: justify;
}

.basic {
  min-height: 100vh;
  padding-top: 20px;
  padding-bottom: 40px;
}

.cash-title {
  padding-top: 1em;
  font-weight: bold;
}

.cash-content {
  //text-indent: 2em;
  padding-top: 5px;
}

</style>
